import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNewspaper3"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM13 7.5H18.5V9.5H13V7.5ZM13 11H18.5V13H13V11ZM5.5 14.5H18.5V16.5H5.5V14.5ZM5.5 7.5V13H7.5V10.6199L9.54006 13H11.5V7.5H9.5V9.88008L7.45994 7.5H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper3;
